export const apiVersion = process.env.REACT_APP_VERSION;
export const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
export const apiWsUrl = process.env.apiWsUrl;
export const okoApiBaseUrl = process.env.REACT_APP_OKO_API_BASE_URL;
